// File: EkadashiCalendar.jsx
import React, { useState,useEffect } from 'react';
import './ekadashiCal.scss';

import axios from 'axios';



const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};


const ekadashiImageMap = {
  shukla1: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna1: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla2: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna2: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla3: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna3: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla4: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna4: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla5: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna5: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla6: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna6: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla7: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna7: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla8: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna8: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla9: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna9: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla10: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna10: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla11: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna11: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla12: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna12: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla13: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna13: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",


  shukla14: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna14: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla15: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna15: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla16: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna16: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla17: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna17: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla18: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna18: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla19: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna19: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla20: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna20: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla21: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna21: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla22: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna22: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla23: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna23: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla24: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna24: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla25: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna25: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
  shukla26: "https://images.bhaskarassets.com/web2images/521/2020/01/18/ekadashi-vrat_1579349734.jpg",
  krishna26: "https://www.hindustantimes.com/ht-img/img/2024/10/28/550x309/rama_ekadashi_1730010226710_1730084959694.jpg",
};


const EkadashiCalendar = ({ onSelectEkadashi }) => {

  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');


  const [ekadashiList, setEkadashiList] = useState([]);

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const ekadashiTooltips = {
  "Shukla Ekadashi": "Shukla Ekadashi occurs on the 11th day of the bright half (Shukla Paksha) of the lunar month. Devotees observe fasts, perform prayers, and engage in spiritual activities for health, prosperity, and spiritual growth.",
  "Krishna Ekadashi (Inferred)": "Krishna Ekadashi occurs on the 11th day of the dark half (Krishna Paksha) of the lunar month. Devotees observe fasting and prayers to honor Lord Vishnu and seek blessings, protection, and spiritual merit."
};


useEffect(() => {
  const fetchEkadashiData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/ekadashi?year=${year}&location=${encodeURIComponent(location)}`
      );
      

   
      if (response.data && response.data.ekadashis) {
        setEkadashiList(response.data.ekadashis);
      } else {
        setEkadashiList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch ekadashi data:", error);
      setEkadashiList([]);
    }
  };

  fetchEkadashiData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });



  let shuklaCount = 0;
let krishnaCount = 0;


  return (
    <div className="calendar-wrapper">
      <div className="calendar-header dark">
        <div className="highlight">
          <h2>{year} Ekadashi Dates</h2>
          <div className="current-ekadashi">
            <img src="https://www.livehindustan.com/lh-img/smart/img/2024/10/12/1200x900/ekadashi_kab_hai_1728728958162_1728728958353.jpeg" alt="Moon" className="moon-preview" />
            <div>
              
              <p>{location}</p>
            </div>
           <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
          </div>

          <div className="v-controls">
           <div className="location-date">
                  <input
                    type="text"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    placeholder="Enter location"
                  />
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
          </div>
        </div>
      </div>

     <div className="ekadashi-list">
              {ekadashiList.length === 0 && <p>No Amavasya data available for selected year/location.</p>}
              {ekadashiList.map((item, idx) => (
                // <div className="ekadashi-item" key={idx}>
<div
  className="ekadashi-item clickable-tile"
  key={idx}
  // onClick={() => props.onSelectEkadashi && props.onSelectEkadashi(item)}
  onClick={() => onSelectEkadashi && onSelectEkadashi(item)}

>


                  {/* images section looping for shukla and krishna paksha */}
                  {(() => {
                    let key = '';
                    if (item.paksha.toLowerCase().includes('shukla')) {
                      shuklaCount++;
                      key = `shukla${shuklaCount}`;
                    } else if (item.paksha.toLowerCase().includes('krishna')) {
                      krishnaCount++;
                      key = `krishna${krishnaCount}`;
                    }

                    return (
                      <img
                        src={ekadashiImageMap[key] || '/images/default.jpg'}
                        alt={item.ekadashiName}
                      />
                    );
                  })()}

                  {/* img section ends here */}

                  <div className="ekadashi-details">
                    <p className="ekadashi-date">{item.date}</p>
                    {/* <div className="tooltip-wrapper">
                      <div className="ekadashi-name">{item.ekadashiName}</div>
                      <span className="tooltip-text">{ekadashiTooltips[item.ekadashiName] || "No info available"}</span>
                    </div> */}
                    <div className="ekadashi-name">{item.ekadashiName}</div>
                    <p className="ekadashi-phase">{item.paksha}</p>
                    <p className="ekadashi-tithi">{item.tithiName}</p>
                  </div>
                  <div className="ekadashi-timings">
                    <p>{item.lunarDetail}</p>
                    <p>{formatTime(item.tithiStart, timeFormat)}</p>
                    <p>{formatTime(item.tithiEnd, timeFormat)}</p>
                  </div>

                </div>
              ))}
            </div>
    </div>
  );
};

export default EkadashiCalendar;
